import {
  SET_ACTIVE_ADDRESS
} from '../actions';

const initialState = {};
export default function (state = initialState, action) {

  switch(action.type) {
    case SET_ACTIVE_ADDRESS:
      return action.payload;

    default:
      return state;
  }
}